import styled from '@emotion/styled';

export const SadaGlobalSearch = styled.div``;
